import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { userService } from '../../../utils/api/user.service';
import './EditProfileModal.css';

export const EditProfileModal = ({ isOpen, onClose, user, userId, onSuccess }) => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    full_name: user?.full_name || '',
    phone: user?.phone || '',
    gender: user?.gender || '',
    bio: user?.bio || ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setFormData({
      full_name: user?.full_name || '',
      phone: user?.phone || '',
      gender: user?.gender || '',
      bio: user?.bio || ''
    });
    setError(null);
  }, [isOpen, user]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) {
      setError('Missing user id. Please refresh and try again.');
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const responseData = await userService.updateProfile(userId, formData);
      const updatedUser = responseData?.result || responseData?.user || formData;
      
      // Update context and localStorage
      // login expects { result: user_data, ... } or similar based on AuthContext usage
      // Check AuthContext.jsx line 23: const login = (userData) => { setUser(userData); ... }
      // PayButton.js line 233: const signupUserId = response?.result?._id;
      // So we should construct an object that matches the existing structure
      
      const savedUserString = localStorage.getItem('hobi_user');
      let currentSession = {};
      if (savedUserString) {
        currentSession = JSON.parse(savedUserString);
      }

      const updatedSession = {
        ...currentSession,
        result: {
          ...(currentSession?.result || {}),
          ...updatedUser
        }
      };
      
      login(updatedSession);
      if (onSuccess) {
        onSuccess(updatedUser);
      }
      onClose();
    } catch (err) {
      console.error('Update profile error:', err);
      setError(err.message || 'Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-modal-overlay" onClick={onClose}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <button className="edit-modal-close" onClick={onClose}>×</button>
        
        <div className="edit-modal-header">
          <h2 className="edit-modal-title">Edit Profile</h2>
          <p className="edit-modal-subtitle">Update your personal information</p>
        </div>

        <form className="edit-modal-form" onSubmit={handleSubmit}>
          <div className="edit-modal-field">
            <label>Full Name</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              placeholder="Your full name"
            />
          </div>

          <div className="edit-modal-field">
            <label>Phone Number</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Your phone number"
            />
          </div>

          <div className="edit-modal-field">
            <label>Gender</label>
            <select name="gender" value={formData.gender} onChange={handleChange}>
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

       

          {error && <p className="edit-modal-error">{error}</p>}

          <button type="submit" className="edit-modal-btn" disabled={loading}>
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      </div>
    </div>
  );
};
